<template>
  <v-col class="overview pa-0">
    <div v-if="!pcPanelMode" class="ov-box-ov">
      <rw-overview></rw-overview>
    </div>
    <div v-if="!pcPanelMode" class="ov-box-ol">
      <tm-over-list></tm-over-list>
    </div>
    <div
      v-if="pcPanelMode && pcPanelModeContent == 'TmOverList'"
      class="ov-box-ol"
    >
      <tm-over-list-full></tm-over-list-full>
    </div>
    <div v-if="pcPanelMode && pcPanelModeContent == 'RwList'" class="ov-box-ol">
      <rw-list-full></rw-list-full>
    </div>
  </v-col>
</template>

<script>
import RwOverview from "../../../components/pc/RwOverview";
import TmOverList from "../../../components/pc/TmOverList";
import TmOverListFull from "../../../components/pc/full/TmOverList";
import RwListFull from "../../../components/pc/full/RwList";

export default {
  components: {
    RwOverview,
    TmOverList,
    TmOverListFull,
    RwListFull,
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[Overview] mounted()");
    this.$store.commit("app/setContent", "Overview");
  },
  computed: {
    /** PCパネル拡大表示モード */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /** パネル拡大モード時の表示コンテンツ */
    pcPanelModeContent: {
      get() {
        return this.$store.state.app.pcPanelModeContent;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.overview {
  display: flex;
  flex-direction: column;
  height: 100%;
  & * + * {
    margin-top: 16px;
  }
}
.ov-box-ov {
  height: 320px;
}
.ov-box-ol {
  flex: 1;
  height: 100%;
}
</style>
